
import { headerComponent } from '@tidal/microservice-components';
import headerComponentCompact from './headerComponentCompact.vue';

import getTidalHeaderUser from '~/utils/getTidalHeaderUser';
import constants from '~/config/constants';

export default {
    components: {
        headerComponent,
        headerComponentCompact,
    },
    props: {
        /** @type {import('vue').PropOptions<import('@tidal/user-middleware').AppMode | null>} */
        appMode: {
            type: Object,
            default: null,
        },
        title: {
            type: String,
            default: '',
        },
        subtitle: {
            type: String,
            default: '',
        },
        /** @type {import('vue').PropOptions<OfferWeb.ClientSideUser | null>} */
        user: {
            type: Object,
            default: null,
        },
        disableTidalLogo: {
            type: Boolean,
            default: false,
        },
        /** @type {import('vue').PropOptions<string | null>} */
        active: {
            type: String,
            default: null,
        },
        /** @type {import('vue').PropOptions<import('@tidal/styles-header').NavigationLink[] | boolean>} */
        links: {
            type: [Boolean, Array],
            default: false,
        },
        hideMicroserviceHeader: {
            type: Boolean,
            default: false,
        },
        art: {
            type: Object,
            default: null,
        },
        customPartnerLogoUrl: {
            type: String,
            default: '',
        },
        brandedLogin: {
            type: Boolean,
            default: false,
        },
        microserviceHeaderClass: {
            type: [Object, String],
            default: '',
        },
        compactHeader: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        isProd() {
            if (process.client) {
                return window.location.hostname === 'offer.tidal.com';
            }

            return constants.IS_PRODUCTION;
        },
        /** @returns {import('@tidal/styles-header').User | null} */
        tidalHeaderUser() {
            return getTidalHeaderUser(this.user);
        },
        /** @returns {string} */
        manageAccountUrl() {
            if (this.isProd) {
                return 'https://account.tidal.com';
            }

            return 'https://account.stage.tidal.com';
        },
        /** @returns {string} */
        tidalUrl() {
            if (this.isProd) {
                return 'https://tidal.com/';
            }

            return 'https://stage.tidal.com/';
        },
        /** @return {string} */
        siteBaseUrl() {
            const baseUrl = this.localePath('index');
            return baseUrl.endsWith('/') ? baseUrl : `${baseUrl}/`;
        },
    },
    methods: {
        logout() {
            window.location.href = '/logout';
        },
        /**
         * @param {string} translationKey
         * @return {string | null} The translation.
         */
        getTranslation(translationKey) {
            return this.$t(`webCommon.header.${translationKey}`);
        },
    },
};
